<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uB0y9s/tc-custom/9781035809226.jpg?1705539782538" alt="This image is the cover for the book Nothing Is as It Seems"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nothing Is as It Seems
      </h1>
      <p class="bookDescription body article font2">
        <p>Nothing Is as It Seems is a story about the power of love, loss and obsession! Architect Sam Johnson and his family relocate from London to pursue a new job in York. They seem to have the perfect life, but Sam is hiding a dark secret that he can’t escape. Lily Hayes is struggling with the loss of her mother’s death. Searching for peace she travels to Australia to distance herself from her haunting past. Leading separate, normal lives, Sam and Lily are connected by one brutal crime. When Olivia Bloom goes missing, Lily Hayes’ life is turned upside down as she becomes entangled in the missing persons investigation. As their lives intertwine, the characters are drawn into a web of secrets.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joey Marcelle
      </h2>
      
      <p class="authorDescription body article">The British author, Joey Marcelle was born in 1988 and raised in Manchester, England. Nothing Is as It Seems is the first of what hopes to be a series of books. With a strong passion for creativity, Joey Marcelle works within the entertainment industry. The book was created from her passion and love of reading thrillers. Nothing Is as It Seems is an action-fuelled plot that is thought-provoking, gripping, full of suspense and encompasses a variety of themes.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16dab298